'use client';

import { useState } from 'react';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import { ApiLocation } from '../../services/api';
import { MapView, MapTheme } from '../map/types';

type SidebarProps = {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  data: ApiLocation;
  children: React.ReactNode;
  mapTheme: MapTheme;
  onMapThemeChange: (theme: MapTheme) => void;
  mapView: MapView;
  onMapViewChange: (view: MapView) => void;
};

export default function Sidebar({
  isOpen,
  setIsOpen,
  children,
}: SidebarProps) {
  return (
    <div className="">
      
      {/* Drawer — full-width overlay on mobile (so it doesn't get stranded
          off-screen edge-to-edge with no way to see the map), fixed-width
          side panel from `sm` up, same as before. */}
      <div
        className={`
          fixed top-0 right-0 h-full w-full sm:w-[27rem] z-[2100]
          bg-white/60 backdrop-blur-sm shadow-lg
          transition-transform duration-300 ease-in-out
          ${isOpen ? "translate-x-0" : "translate-x-full"}
        `}
      >
        <div className="h-full overflow-y-auto">
          {children}
        </div>
      </div>

      {/* Toggle button — on mobile the drawer covers the full width, so
          there's no "seam" to ride on; the button just stays put at the
          top-right corner (above the drawer, via z-index) to close it. */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`fixed right-0 top-4 z-[2200]
          bg-white/80 backdrop-blur-sm rounded-full p-1 shadow-md
          transition-transform duration-300 ease-in-out
          ${isOpen ? 'sm:-translate-x-[27rem]' : 'translate-x-0'}
        `}
      >
        {isOpen ? (
          <ChevronRight className="h-6 w-6 text-gray-600" />
        ) : (
          <ChevronLeft className="h-6 w-6 text-gray-600" />
        )}
      </button>
    </div>
  );
}